/*
 * fieldRouting — Mini-Helfer fuer die Spellcheck-Field-Klassifikation.
 *
 * Bisher als private module-level-Funktionen in EditorView.js (`_isSpellCheckedField`)
 * und mouseHandlers.js (`_spellCheckFieldFromPaneId`). Hierher gezogen, damit
 * Tests die Tabelle direkt pruefen — ohne den ganzen EditorView-/Handlers-
 * Overhead. Spellcheck-Review 2026-05-10 Finding T-N3.
 *
 * Drei pruefbare Felder (Spec §1):
 *   - 'text' (Main-Body)
 *   - 'note' (Outline-Notes)
 *   - 'info' (Context-Pane-Info)
 *
 * Andere Pseudo-Felder (z.B. Padding, Separator-Title-Inputs, Memory-Editor-
 * `'text'` mit anderer Pane-Id) werden vom Spellcheck nicht angefasst.
 */

import { PaneId } from '../config.js'

/**
 * @param {string} field
 * @returns {boolean}
 */
export function isSpellCheckedField(field) {
    return field === 'text' || field === 'note' || field === 'info'
}

/**
 * Mappt eine Pane-ID auf das passende Spellcheck-Feld. Andere Panes
 * (CORE, MEMORY, PERSONAL_DICT) haben eigene Pfade — CORE wird bewusst
 * nicht gepruefft, MEMORY hat einen eigenen Editor mit dem 'text'-Feld
 * (das Routing dort laeuft direkt ueber den MemoryEditor, nicht ueber
 * diesen Helper), PERSONAL_DICT ist per Definition akzeptiert.
 *
 * @param {string} paneId
 * @returns {'text'|'note'|'info'|null}
 */
export function spellCheckFieldFromPaneId(paneId) {
    if (paneId === PaneId.MAIN)    return 'text'
    if (paneId === PaneId.OUTLINE) return 'note'
    if (paneId === PaneId.CONTEXT) return 'info'
    return null
}
